import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { DeleteTenantDialogComponent } from 'projects/admin/src/lib/manage-tenants/delete-tenant-dialog/delete-tenant-dialog.component';
import { UserTenantDto } from 'projects/shared/src/lib/models/TenantDto';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { MatDialog } from '@angular/material/dialog';
import { UserDto } from 'projects/shared/src/lib/models/User';
import { DeleteUserDialogComponent } from '../../../delete-user-dialog/delete-user-dialog.component';

@Component({
  selector: 'lib-tenant-button-renderer',
  templateUrl: './tenant-button-renderer.component.html',
  styleUrls: ['./tenant-button-renderer.component.scss']
})
export class TenantButtonRendererComponent implements ICellRendererAngularComp {

  params: any;
  icon_delete!: string;

  constructor(
    public dialog: MatDialog,    
    private tenantService: TenantService,
    public translate: TranslateService,
    private notificationService: NotificationService) { 
    }


  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;  
    this.icon_delete = this.params.icon_delete || null;

    this.refresh(params);
  }

  deleteTenant(){
    const rowData = [this.params.node.data]; 
    let userTenant = new UserTenantDto
    userTenant.tenantId =  rowData[0].tenantId;
    userTenant.userId = rowData[0].userId;
    userTenant.tenantName = rowData[0].tenantName;
    
    console.log("----------> removeUser - rowData = ", rowData[0]);

    let userDto = new UserDto;

    // userDto.id = rowData[0].id;
    // userDto.userName = rowData[0].userName;
    // userDto.email = rowData[0].email;
    // userDto.emailConfirmed = rowData[0].emailConfirmed;
    // userDto.firstName = rowData[0].firstName;
    // userDto.lastName = rowData[0].lastName;
    // userDto.phoneNumber = rowData[0].phoneNumber;
    // userDto.phoneNumberConfirmed = rowData[0].phoneNumberConfirmed;
    // userDto.twoFactorEnabled = rowData[0].twoFactorEnabled;
    // userDto.lockoutEnabled = rowData[0].lockoutEnabled;
    // userDto.lockoutEnd = rowData[0].lockoutEnd;
    // userDto.accessFailedCount = rowData[0].accessFailedCount;
    // userDto.userRoles = rowData[0].userRoles;

    const dialogRef = this.dialog.open(DeleteUserDialogComponent, {width: '500px',data:{userDto: userDto, params: this.params} }); 
    dialogRef.afterClosed().subscribe((result:any) => {

      if(result != undefined){
        
          // let db:string = this.tenantService.currentTenantName;
          // let dbId:string = this.tenantService.currentTenantId;

          // console.log("==============> remove user from tenant: dbId = ", dbId)

          // this.tenantService.deleteUser(db, dbId, result.id).subscribe({
          //   next:() => {
          //     this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["USERDELETED"]}`);
          //     this.params.api.refreshInfiniteCache();
          //   },
          //   error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERUSERDELETEDERROR"]}`)
          // });

          this.tenantService.deleteUserTenancy(userTenant).subscribe({
            next:() => {
              this.params.api.refreshInfiniteCache(); 
              this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["USERREMOVEDFROMTENANCY"]}`);
            },
            error: (error:any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERREMOVEDFROMTENANCYERROR"]}`)
          })
             
      }
    });    



  }

}
